import React from "react";
import ReactDOM from "react-dom";
import { StateMachineProvider, createStore } from "little-state-machine";
import reportWebVitals from "./reportWebVitals";
import App from "./App";

const elements = document.querySelectorAll("[id^=selbsttest]");
const store = createStore({});

elements?.forEach((e) => {
  const selbsttestId = e.getAttribute("data-selbsttest");
  const showResults = e.hasAttribute("show-results");
  const theme = e.getAttribute("theme");

  const mainContent = () => {
    return (
      <StateMachineProvider store={store}>
        <App
          key={selbsttestId}
          appId={selbsttestId}
          showResults={showResults}
          theme={theme}
        />
      </StateMachineProvider>
    );
  };
  ReactDOM.render(
    <React.StrictMode>{mainContent(selbsttestId)}</React.StrictMode>,
    e
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
